import { Navigate, Outlet } from "react-router-dom";

function ProtectedRoute({ allowedRoles = [], redirectTo = "/login" }) {
  const token   = localStorage.getItem("token");
  const rawRole = localStorage.getItem("role");   // "admin" | "staff" | "user" | "test"
  // role "test" ให้ทำงานเหมือน user ทุกอย่าง (เข้าหน้าเดียวกับ user ได้)
  const role = rawRole === "test" ? "user" : rawRole;

  // ไม่มี token → login
  if (!token) return <Navigate to={redirectTo} replace />;

  // role ไม่อยู่ใน allowedRoles
  if (role && !allowedRoles.includes(role)) {
    if (role === "admin") return <Navigate to="/admin"  replace />;
    if (role === "staff") return <Navigate to="/calendar" replace />;
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}

export default ProtectedRoute;